import React from 'react';
import { Group, useBreakpoint, ButtonSize } from '@landr/maestro';
import { useSearchModifiers } from 'controllers/SearchController/hooks/useSearchModifiers';
import { useCurrentSearchState } from 'controllers/SearchController/hooks/useCurrentSearchState';
import { useSearchBarContext } from 'components/Filters/context/SearchBarContext/SearchBarContext';
import { useFiltersContext } from '../../context/FiltersContext/FiltersContext';
import Skeleton from './components/Skeleton';
import TypeButton from './components/TypeButton';

const TypesFilter = () => {
    const { addFilter, clearByFilter } = useSearchModifiers();
    const { listOfTypes } = useFiltersContext();
    const { type: typeState } = useCurrentSearchState();
    const { isSearchBarDisabled } = useSearchBarContext();

    const showSearchOnTop = useBreakpoint('md');
    const buttonSize: ButtonSize = showSearchOnTop ? 'sm' : 'md';

    if (!listOfTypes?.list?.length) {
        return <Skeleton buttonSize={buttonSize} />;
    }

    return (
        <Group gutter="xs">
            {listOfTypes.list.map((type) => (
                <TypeButton
                    key={type.code}
                    isChecked={typeState === type.code}
                    code={type.code}
                    addFilter={addFilter}
                    clearByFilter={clearByFilter}
                    buttonSize={buttonSize}
                    isDisabled={isSearchBarDisabled}
                />
            ))}
        </Group>
    );
};

TypesFilter.displayName = 'Filters.TypesFilter';

export default TypesFilter;
